import Naluri from '~/common/api/naluri';
import {
  COMMON_GET_BROADCAST_USERS_BEGIN,
  COMMON_GET_BROADCAST_USERS_SUCCESS,
  COMMON_GET_BROADCAST_USERS_FAILURE,
  COMMON_GET_BROADCAST_USERS_DISMISS_ERROR,
  COMMON_BROADCAST_CHANNELS_CLEAR,
} from './constants';
import { List } from 'immutable';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getBroadcastUsers(keyword, filter) {
  return dispatch => {
    // optionally you can have getState as the second argument
    dispatch({
      type: COMMON_GET_BROADCAST_USERS_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      const params = {
        query: keyword,
        to_reply: false,
        paid: false,
        vip: false,
        sponsors: filter,
      };

      const doRequest = Naluri.get(`/api/expert/channels/search`, params);

      doRequest.then(
        res => {
          dispatch({
            type: COMMON_GET_BROADCAST_USERS_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        err => {
          dispatch({
            type: COMMON_GET_BROADCAST_USERS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetBroadcastUsersError() {
  return {
    type: COMMON_GET_BROADCAST_USERS_DISMISS_ERROR,
  };
}

export function clearBroadcastChannels() {
  return (dispatch, getState) => {
    dispatch({
      type: COMMON_GET_BROADCAST_USERS_BEGIN,
    });

    dispatch({
      type: COMMON_BROADCAST_CHANNELS_CLEAR,
    });
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_GET_BROADCAST_USERS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        broadcastUsers: List(),
        getBroadcastUsersPending: true,
        getBroadcastUsersError: null,
      };

    case COMMON_GET_BROADCAST_USERS_SUCCESS:
      // The request is success
      const broadcastUsers = state.broadcastUsers.withMutations(broadcast =>
        action.data.map(u => {
          let isExist = broadcast.find(b => b.channel_id === u.channel_id);
          return !isExist ? broadcast.push(u) : null;
        }),
      );

      return {
        ...state,
        broadcastUsers: broadcastUsers,
        getBroadcastUsersPending: false,
        getBroadcastUsersError: null,
      };

    case COMMON_GET_BROADCAST_USERS_FAILURE:
      // The request is failed
      return {
        ...state,
        getBroadcastUsersPending: false,
        getBroadcastUsersError: action.data.error,
      };

    case COMMON_GET_BROADCAST_USERS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getBroadcastUsersError: null,
      };

    case COMMON_BROADCAST_CHANNELS_CLEAR:
      // Dismiss the request failure error
      return {
        ...state,
        broadcastUsers: List(),
        getBroadcastUsersPending: false,
        getBroadcastUsersError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/common/redux/getBroadcastUsers.js